<template>
  <div class="container__card order-card" id="card" v-if="items.length > 0">
    <div class="wrapper-position">
      <div id="brand-logo" class="brand-logo" v-if="brandLogo" :class="logoPosition">
        <img :src="brandLogo" />
        <p :style="themeColor" class="title left-padding">Your Order</p>
      </div>
      <div class="body-content" :class="{'multiple-line-items': hasMoreItems }">
        <line-item-single :item='firstItem' v-if="!hasMoreItems"> </line-item-single>

        <template v-if="hasMoreItems">
          <line-item-multiple @remove="removeItem(item)" v-for="item in itemsToShow" :item='item'> </line-item-multiple>

          <div class="load-more-items show" v-if="!showAll && remainingItems > 0" @click="showAll = true">
            + {{remainingItems}} more items
          </div>
        </template>
      </div>

      <div class="total">
        <div class="total-footer clearfix" v-if="hasMoreItems">
          <p class="left" id="tax-text">Your bill amount. Taxes extra</p>
          <p class="right total-bill show">
            {{totalAmount}}
          </p>
        </div>

        <button :style="backgroundColor" class="continue" @click="showNext()" >Looks good, continue →</button>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import SingeLineItem from './SingleLineItem.vue';
  import MultipleLineItem from './MultipleLineItem.vue';
  export default {
    name: 'cart-summary',
    props: ['items', 'checkout'],
    data() {
      return {
        showAll: false
      }
    },
    computed: {
      hasMoreItems() {
        return this.items.length > 1;
      },
      firstItem() {
        return this.items[0];
      },
      totalAmount() {
        // TODO figure out how to share common helpers among components
        return this.items[0].currencySymbol + this.items.map(item => item.getAmount()).reduce( ( acc, cur ) => acc + cur, 0 ).toFixed(2);
      },
      itemsToShow() {
        return this.showAll ? this.items : this.items.slice(0, 3);
      },
      remainingItems() {
        return !this.showAll ? this.items.length - 3 : 0;
      }
    },
    components: {
      'line-item-single' : SingeLineItem,
      'line-item-multiple' : MultipleLineItem
    },
    methods: {
      removeItem(item) {
        if(this.checkout.lineItems.indexOf(item) >= 0) {
          this.checkout.lineItems.splice(this.checkout.lineItems.indexOf(item), 1);
        }
      },
      showNext() {
        this.$emit("checkoutStep");
      }
    }
  }
</script>


// WEBPACK FOOTER //
// CartSummary.vue?128f6806